export const frTunableOffers = {
    // TUNABLE OFFERS

    'tunableOffers.create.pageTitle': 'Création bon plan libre',
    'tunableOffers.create.actions.cancelCreation': 'Annuler la création',
    'tunableOffers.create.actions.addTheTunableOffer': 'Enregistrer',
    'tunableOffers.create.input.name': 'Saisissez ici le nom du bon plan *',
    'tunableOffers.create.input.code': 'Saisissez ici le code du bon plan',
    'tunableOffers.create.input.floatingLabelName': 'Titre',
    'tunableOffers.create.input.floatingLabelCode': 'Référence',
    'tunableOffers.create.tabs.info': 'Informations',
    'tunableOffers.create.tabs.audience': 'Audience',
    'tunableOffers.create.tabs.notifications': 'Notifications',
    'tunableOffers.create.tabs.audiences.treeTitle': 'Choix sectorisation',
    'tunableOffers.create.tabs.audiences.btnLabel': "Définir l'audience à partir d'une question",
    'tunableOffers.create.tabs.audiences.dialog.title':
        "Définir l'audience à partir d'une question",
    'tunableOffers.create.tabs.audiences.dialog.floatingLabel': 'Code question',
    'tunableOffers.create.tabs.audiences.dialog.hintLabel': 'Référence de la réponse concernée',
    'tunableOffers.create.tabs.audiences.dialog.cancelLabel': 'Annuler',
    'tunableOffers.create.tabs.audiences.dialog.validateLabel': 'Valider',
    'tunableOffers.create.tabs.informations.generalSectionTitle': 'Informations générales',
    'tunableOffers.infos.type': 'Libre',
    'tunableOffers.create.tabs.informations.publishSectionTitle': 'Publication',
    'tunableOffers.create.tabs.informations.inputs.floatingLabelEndDate': "Date d'échéance",
    'tunableOffers.create.tabs.informations.inputs.endDate': "Sélectionnez une date d'échéance",
    'tunableOffers.infos.description': 'Saisissez ici la description du bon plan',
    'tunableOffers.create.tabs.informations.inputs.floatingLabelDescription': 'Description',
    'tunableOffers.create.tabs.informations.inputs.price': 'Saisissez ici le prix du bon plan',
    'tunableOffers.create.tabs.informations.inputs.floatingLabelPrice': 'Prix unitaire (€)',
    'tunableOffers.info.targetQuantity': 'Quantité demandée tous produits confondus',
    'tunableOffers.info.targetQuantity.label': 'Quantité cible totale',
    'tunableOffers.create.tabs.informations.inputs.remaningCount': 'Saisissez ici le stock Restant',
    'tunableOffers.create.tabs.informations.inputs.floatingLabelRemaningCount': 'Stock Restant',
    'tunableOffers.create.tabs.informations.select.owner.sectionTitle': 'Propriétaire',
    'tunableOffers.create.tabs.informations.select.owner.title':
        'Sélectionnez le propriètre du bon plan',
    'tunableOffers.create.tabs.informations.select.owner.floatingLabelTitle': 'Propriétaire',
    'tunableOffers.create.tabs.informations.select.owner.listTitle': 'Choix du propriétaire',
    'tunableOffers.create.tabs.informations.select.owner.listInputLabel':
        'Chercher un utilisateur siège',
    'tunableOffers.create.tabs.informations.select.owner.listCloseLabel': 'Fermer',
    'tunableOffers.create.tabs.informations.select.docs.addPhoto': 'Ajouter une photo',
    'tunableOffers.create.tabs.informations.select.docs.addPhotoLabel': 'Visuel photo',
    'tunableOffers.create.tabs.informations.select.docs.title': 'Joindre un fichier PDF',
    'tunableOffers.create.tabs.informations.select.docs.label': 'Fichier PDF',
    'tunableOffers.create.tabs.informations.select.docs.btn': 'Parcourir',
    'tunableOffers.create.tabs.informations.select.docs.imageUrl': "URL de l'image",
    'tunableOffers.create.tabs.informations.select.docs.load': 'Charger',
    'tunableOffers.create.tabs.informations.select.docs.hintHttp': 'http://...',
    'tunableOffers.create.tabs.informations.select.docs.cancelLabel': 'Annuler',
    'tunableOffers.create.tabs.informations.publish.publishBtn': 'Publier',
    'tunableOffers.create.tabs.informations.publish.cancelBtn': 'Annuler la publication',
    'tunableOffers.create.tabs.notifs.time': '--',
    'tunableOffers.create.tabs.notifs.floatingLabelTime': 'Heure de la relance',
    'tunableOffers.create.tabs.notifs.date': '--',
    'tunableOffers.create.tabs.notifs.floatingLabelDate': 'Date de la relance',
    'tunableOffers.create.tabs.notifs.dateSwitch': 'Date unique',
    'tunableOffers.create.tabs.notifs.recursiveTime': '--',
    'tunableOffers.create.tabs.notifs.floatingLabelRecursiveTime': 'Heure de répétition',
    'tunableOffers.create.tabs.notifs.recursiveTimeSwitch': 'Répétition',
    'tunableOffers.create.tabs.notifs.repeat': '--',
    'tunableOffers.create.tabs.notifs.floatingLabelRepeat': 'Tous les XX jours',
    'tunableOffers.create.tabs.notifs.noneLabel': 'Aucune relance',
    'tunableOffers.create.tabs.notifs.autoSend': 'Relance automatique',

    // TUNABLE OFFERS >> DETAILS

    'tunableOffers.details.pageTitle': 'Détails bon plan libre',
    'tunableOffers.details.input.name': 'Saisissez ici le nom du bon plan *',
    'tunableOffers.details.input.code': 'Saisissez ici le code du bon plan',
    'tunableOffers.details.input.floatingLabelName': 'Nom',
    'tunableOffers.details.input.floatingLabelCode': 'Code',
    'tunableOffers.details.dialog.title': 'Suppression du bon plan',
    'tunableOffers.details.dialog.content': 'Êtes-vous sûr de vouloir supprimer ce bon plan ?',
    'tunableOffers.details.dialog.validateLabel': 'Supprimer',
    'tunableOffers.details.dialog.cancelLabel': 'Annuler',
    'tunableOffers.details.actions.save': 'Enregistrer',
    'tunableOffers.details.actions.remove': 'Supprimer',
    'tunableOffers.details.actions.previous': 'Bons plans',
    'tunableOffers.details.tabs.info': 'Informations',
    'tunableOffers.details.tabs.audience': 'Audience',
    'tunableOffers.details.tabs.notifications': 'Notifications',
    'tunableOffers.details.tabs.informations.generalSectionTitle': 'Informations générales',
    'tunableOffers.details.tabs.informations.type': 'Libre',
    'tunableOffers.details.tabs.informations.publishSectionTitle': 'Publication',
    'tunableOffers.details.tabs.informations.inputs.floatingLabelEndDate': "Date d'échéance",
    'tunableOffers.details.tabs.informations.inputs.endDate': "Sélectionnez une date d'échéance",
    'tunableOffers.details.tabs.informations.inputs.description':
        'Saisissez ici la description du bon plan',
    'tunableOffers.details.tabs.informations.inputs.floatingLabelDescription': 'Description',
    'tunableOffers.details.tabs.informations.inputs.price': 'Saisissez ici le prix du bon plan',
    'tunableOffers.details.tabs.informations.inputs.floatingLabelPrice': 'Prix unitaire (€)',
    'tunableOffers.details.tabs.informations.inputs.totalNb':
        'Saisissez ici le nombre total de palettes',
    'tunableOffers.details.tabs.informations.inputs.floatingLabelRemaningCount': 'Stock restant',
    'tunableOffers.details.tabs.informations.inputs.remaningCount':
        'Saisie manuelle du stock Restant',
    'tunableOffers.details.tabs.informations.inputs.floatingLabelRemaning': 'Stock',
    'tunableOffers.details.tabs.informations.select.owner.sectionTitle': 'Propriétaire',
    'tunableOffers.details.tabs.informations.select.owner.title':
        'Sélectionnez le propriètre du bon plan',
    'tunableOffers.details.tabs.informations.select.owner.floatingLabelTitle': 'Propriétaire',
    'tunableOffers.details.tabs.informations.select.owner.listTitle': 'Choix du propriétaire',
    'tunableOffers.details.tabs.informations.select.owner.listInputLabel':
        'Chercher un utilisateur siège',
    'tunableOffers.details.tabs.informations.select.owner.listCloseLabel': 'Fermer',
    'tunableOffers.details.tabs.informations.select.docs.defaultDocumentName': 'Document PDF',
    'tunableOffers.details.tabs.informations.select.docs.addPhoto': 'Ajouter une photo',
    'tunableOffers.details.tabs.informations.select.docs.addPhotoLabel': 'Visuel photo',
    'tunableOffers.details.tabs.informations.select.docs.title': 'Joindre un fichier PDF',
    'tunableOffers.details.tabs.informations.select.docs.label': 'Fichier PDF',
    'tunableOffers.details.tabs.informations.select.docs.btn': 'Parcourir',
    'tunableOffers.details.tabs.informations.select.docs.imageUrl': "URL de l'image",
    'tunableOffers.details.tabs.informations.select.docs.load': 'Charger',
    'tunableOffers.details.tabs.informations.select.docs.hintHttp': 'http://...',
    'tunableOffers.details.tabs.informations.select.docs.cancelLabel': 'Annuler',
    'tunableOffers.details.tabs.informations.select.publisher.sectionTitle': 'Publier en tant que',
    'tunableOffers.details.tabs.informations.select.publisher.title':
        'Sélectionnez le nom du publieur',
    'tunableOffers.details.tabs.informations.select.publisher.floatingLabelTitle':
        'Publier en tant que',
    'tunableOffers.details.tabs.informations.select.publisher.listTitle': 'Choix du publieur',
    'tunableOffers.details.tabs.informations.select.publisher.listInputLabel':
        'Chercher un utilisateur ou une équipe',
    'tunableOffers.details.tabs.informations.select.publisher.listCloseLabel': 'Fermer',
    'tunableOffers.details.tabs.informations.publish.publishBtn': 'Publier',
    'tunableOffers.details.tabs.informations.publish.cancelBtn': 'Annuler la publication',
    'tunableOffers.details.tabs.audiences.treeTitle': 'Choix sectorisation',
    'tunableOffers.details.tabs.audiences.btnLabel': "Définir l'audience à partir d'une question",
    'tunableOffers.details.tabs.audiences.dialog.title':
        "Définir l'audience à partir d'une question",
    'tunableOffers.details.tabs.audiences.dialog.floatingLabel': 'Code question',
    'tunableOffers.details.tabs.audiences.dialog.hintLabel': 'Référence de la réponse concernée',
    'tunableOffers.details.tabs.audiences.dialog.cancelLabel': 'Annuler',
    'tunableOffers.details.tabs.audiences.dialog.validateLabel': 'Valider',
    'tunableOffers.details.tabs.details.emptyLabel': 'Aucun produit pour le moment.',
    'tunableOffers.details.tabs.details.actions.import': 'Import Excel',
    'tunableOffers.details.tabs.details.actions.export': 'Export Excel',
    'tunableOffers.details.tabs.details.actions.add': 'Ajouter un produit',
    'tunableOffers.details.tabs.details.productsItem.quantity': 'Quantité',
    'tunableOffers.product.price': 'Prix: ',
    'tunableOffers.product.margin': 'Tx marge: ',
    'tunableOffers.product.discountPrice': 'Prix promo: ',
    'tunableOffers.product.discountMargin': 'Tx marge promo: ',
    'tunableOffers.details.tabs.details.dialog.title': "Suppression d'un produit",
    'tunableOffers.details.tabs.details.dialog.content':
        'Êtes-vous sûr de vouloir supprimer ce produit ?',
    'tunableOffers.details.tabs.details.dialog.validateLabel': 'Supprimer',
    'tunableOffers.details.tabs.details.dialog.cancelLabel': 'Annuler',
    'tunableOffers.product.dialog.addTitle': 'Ajouter un produit',
    'tunableOffers.product.dialog.editTitle': 'Éditer un produit',
    'tunableOffers.product.dialog.cancel': 'Annuler',
    'tunableOffers.product.dialog.save': 'Enregistrer',
    'tunableOffers.product.dialog.create': 'Créer',
    'tunableOffers.product.dialog.name.label': 'Nom',
    'tunableOffers.product.dialog.inputs.description': 'Description',
    'tunableOffers.product.dialog.inputs.quantity': 'Quantité',
    'tunableOffers.product.dialog.ref.label': 'Référence',
    'tunableOffers.product.dialog.unitPrice.label': 'Prix unitaire',
    'tunableOffers.product.dialog.margin.label': 'Taux de marge',
    'tunableOffers.product.dialog.discountUnitPrice.label': 'Prix unitaire promo',
    'tunableOffers.product.dialog.discountMargin.label': 'Taux de marge promo',
    'tunableOffers.product.dialog.name': 'Titre du produit *',
    'tunableOffers.product.dialog.description': 'Description du produit',
    'tunableOffers.product.dialog.inputs.hints.quantity': 'Nombre de produits',
    'tunableOffers.product.dialog.ref': 'Référence du produit *',
    'tunableOffers.product.dialog.unitPrice': 'Prix en euros',
    'tunableOffers.product.dialog.margin': 'Pourcentage de marge',
    'tunableOffers.product.dialog.discountUnitPrice': 'Prix promo en euros',
    'tunableOffers.product.dialog.discountMargin': 'Pourcentage après promo',
    'tunableOffers.product.dialog.inputs.error': 'invalide',
    'tunableOffers.details.tabs.notifs.time': '--',
    'tunableOffers.details.tabs.notifs.floatingLabelTime': 'Heure de la relance',
    'tunableOffers.details.tabs.notifs.date': '--',
    'tunableOffers.details.tabs.notifs.floatingLabelDate': 'Date de la relance',
    'tunableOffers.details.tabs.notifs.dateSwitch': 'Date unique',
    'tunableOffers.details.tabs.notifs.recursiveTime': '--',
    'tunableOffers.details.tabs.notifs.floatingLabelRecursiveTime': 'Heure de répétition',
    'tunableOffers.details.tabs.notifs.recursiveTimeSwitch': 'Répétition',
    'tunableOffers.details.tabs.notifs.repeat': '--',
    'tunableOffers.details.tabs.notifs.floatingLabelRepeat': 'Tous les XX jours',
    'tunableOffers.details.tabs.notifs.noneLabel': 'Aucune relance',
    'tunableOffers.details.tabs.notifs.autoSend': 'Relance automatique',
    'tunableOffers.details.tabs.notifs.manualSend': 'Relance manuelle',
    'tunableOffers.details.tabs.notifs.manualInfo':
        "Envoyer une notification de relance aux collaborateurs qui n'ont pas encore consulté le bon plan",
    'tunableOffers.details.tabs.notifs.manualBtnlabel': 'Relancer',
    'tunableOffers.details.tabs.notifs.notifsHistoryEmpty': "Pas d'historique de notifications",
    'tunableOffers.details.tabs.notifs.tableTitle': 'Historique des notifications',
    'tunableOffers.details.tabs.results.sectionTitle': 'Résultats',
    'tunableOffers.details.tabs.results.export': 'Export Excel',
    'tunableOffers.details.tabs.results.dialogTitle': 'Commande du centre',
    'tunableOffers.details.tabs.results.commandTotal': 'Total de la commande',
    'tunableOffers.details.tabs.results.tableHeader.shop': 'Centre',
    'tunableOffers.details.tabs.results.tableHeader.user': 'Collaborateurs',
    'tunableOffers.details.tabs.results.tableHeader.answerDate': 'Date de réponse',
    'tunableOffers.details.tabs.results.tableHeader.totalPrice': 'Prix total',
    'tunableOffers.details.tabs.results.tableHeader.detailsOrdered': 'Détail commandé',
    'tunableOffers.details.tabs.results.tableHeader.productDetails': 'Détail produit',
    'tunableOffers.details.tabs.results.tableHeader.quanity': 'Quantité',
    'tunableOffers.details.tabs.results.filters.date.from': 'Du',
    'tunableOffers.details.tabs.results.filters.date.to': 'Au',
    'tunableOffers.details.tabs.results.filters.date.btn': 'Appliquer',
    'tunableOffers.details.tabs.results.filters.label.from': 'Commandé après le',
    'tunableOffers.details.tabs.results.filters.label.to': 'Commandé avant le',
    'tunableOffers.details.tabs.results.filters.label.bothFirst': 'Commandé entre le',
    'tunableOffers.details.tabs.results.filters.label.bothSecond': 'et le',
    'tunableOffers.details.tabs.results.emptyLabel': 'Aucun résultat pour le moment.',
    'tunableOffers.list.table.state.draft': 'Brouillon',
    'tunableOffers.list.table.state.drafts': 'Brouillon',
    'tunableOffers.list.table.state.published': 'Publié',
    'tunableOffers.list.table.state.unpublished': 'Annulé',
    'tunableOffers.list.table.state.finished': 'Terminé',

    //TOAST ERRORS
    'toast.apiErrors.TUNABLE_OFFER_MISSING_NOTIFICATION_CONFIGURATION':
        "Veuillez configurer l'envoi des notification avant d'effectuer cette opération.",
    'toast.apiErrors.TUNABLE_OFFER_NOT_PUBLISHED':
        "Cette opération ne peut s'effectuer que sur une offre publiée",
    'toast.apiErrors.TUNABLE_OFFER_CANT_DELETE_PUBLISHED':
        'Impossible de supprimer un bon plan qui a été publié',
    'toast.apiErrors.TUNABLE_OFFER_ALREADY_PUBLISHED': 'Ce bon plan est déjà publié',
    'toast.apiErrors.TUNABLE_OFFER_MISSING_END_DATE':
        "La date d'échéance n'est pas définie pour ce bon plan, il ne peut pas être publié",
    'toast.apiErrors.TUNABLE_OFFER_MISSING_PRODUCT':
        'Le bon plan doit contenir au moins un produit',
    'toast.apiErrors.TUNABLE_OFFER_PRODUCT_MISSING_PURCHASE_PRICE':
        "Le prix d'achat doit être défini pour chaque produit",
    'toast.apiErrors.TUNABLE_OFFER_PRODUCT_MISSING_PURCHASE_PRICE_PROMO':
        "Le prix d'achat promo doit être défini pour chaque produit",
    'toast.apiErrors.TUNABLE_OFFER_PRODUCT_MISSING_MARGIN_RATE':
        'Le taux de marge doit être défini pour chaque produit',
    'toast.apiErrors.TUNABLE_OFFER_PRODUCT_MISSING_MARGIN_RATE_PROMO':
        'Le taux de marge promo doit être défini pour chaque produit',
    'toast.apiErrors.TUNABLE_OFFER_PUBLISHED_CANT_ADD_PRODUCT':
        "Impossible d'ajouter un nouveau produit sur un bon plan qui a été publié",
    'toast.apiErrors.TUNABLE_OFFER_PUBLISHED_CANT_EDIT_PRODUCT':
        "Impossible de modifier la référence, le prix d'achat promo ou la quantité d'un produit sur un bon plan qui a déjà été publié",
    'toast.apiErrors.TUNABLE_OFFER_PUBLISHED_CANT_DELETE_PRODUCT':
        'Impossible de supprimer un produit existant sur un bon plan qui a été publié',
    'toast.apiErrors.TUNABLE_OFFER_ALREADY_UNPUBLISHED':
        'Ce bon plan est déjà au statut publication annulée',
    'toast.apiErrors.TUNABLE_OFFER_MISSING_AUDIENCE':
        "Aucune audience n'est définie pour ce bon plan, il ne peut pas être publié",
    'toast.apiErrors.TUNABLE_OFFER_PUBLISHED_CANT_EDIT':
        'Ce bon plan est publié, le prix unitaire ne sont plus modifiables',
    'toast.apiErrors.TUNABLE_OFFER_MISSING_TARGET_QUANTITY':
        'Veuillez renseigner la quantitée cible totale',
};
